/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AccountGroupCreateRequest
 */
export interface AccountGroupCreateRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountGroupCreateRequest
     */
    name: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountGroupCreateRequest
     */
    lc: Array<string>;
}

/**
 * Check if a given object implements the AccountGroupCreateRequest interface.
 */
export function instanceOfAccountGroupCreateRequest(value: object): value is AccountGroupCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('lc' in value) || value['lc'] === undefined) return false;
    return true;
}

export function AccountGroupCreateRequestFromJSON(json: any): AccountGroupCreateRequest {
    return AccountGroupCreateRequestFromJSONTyped(json, false);
}

export function AccountGroupCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountGroupCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'lc': json['lc'],
    };
}

export function AccountGroupCreateRequestToJSON(json: any): AccountGroupCreateRequest {
    return AccountGroupCreateRequestToJSONTyped(json, false);
}

export function AccountGroupCreateRequestToJSONTyped(value?: AccountGroupCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'lc': value['lc'],
    };
}

